import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ValidationMessageResolver } from '@ngx-strakit/validation';
import { INTEGER_ONLY_VALIDATOR_NAME } from '../../validators/integer-only.validator';

@Injectable()
export class SkIntegerValidationMessageResolver implements ValidationMessageResolver {
  private readonly translate = inject(TranslateService);
  readonly errorCode = INTEGER_ONLY_VALIDATOR_NAME;

  getMessage(): string {
    return this.translate.instant('label.validation.integer');
  }
}
